import { IStory } from './interfaces/IStory';
import { ITaxonomy } from './interfaces/ITaxonomy';
import { IPlace } from './interfaces/IPlace';
import { db } from './DBUtils';
import { Media } from '../pages/innerPages/DELETEMEbookmarks';
import { ITrail } from './interfaces/ITrail';

export class Story implements IStory {
	id!: number;
	title!: string;
	image!: string | boolean;
	featured_video!: string | boolean;
	short_description!: string;
	description!: string;
	external_url!: string;
	topics!: ITaxonomy[];
	fkPlaces!: number[];
	places!: IPlace[];
	fkTrails!: number[];
	trails!: ITrail[];
	gallery!: Media[];
	featured!: boolean;
	url!: string;
	external_url_description!: string;

	// wildcard!: something

	constructor(props: IStory) {
		if (props.id) this.id = props.id;
		this.title = props.title;
		this.image = props.image;
		this.featured_video = props.featured_video;
		this.short_description = props.short_description;
		this.description = props.description;
		this.external_url = props.external_url;
		this.topics = props.topics;
		this.fkPlaces = props.fkPlaces;
		this.featured = props.featured;
		this.fkTrails = props.fkTrails;
		this.trails = props.trails;
		this.url = props.url;
		this.external_url_description = props.external_url_description;
		// this.wildcard = props.wildcard

		Object.defineProperties(this, {
			places: { value: [], enumerable: false, writable: true },
			trails: { value: [], enumerable: false, writable: true },
		});
	}

	async loadRelationships() {
		this.places = await db.places
			.where('id')
			.anyOf(this.fkPlaces)
			.toArray();
		this.trails = await db.trails
			.where('id')
			.anyOf(this.fkTrails)
			.toArray();
		return this;
	}

	public static async decorate(story_list: Story[]) {
		const new_list: Story[] = [];
		for (let ndx = 0; ndx < story_list.length; ndx++) {
			await story_list[ndx].loadRelationships();
			new_list.push(story_list[ndx]);
		}
		return new_list;
	}
}
